import { IDataPortalV2 } from '../../interfaces/src'
import { defaultPortalsPublish, PORTALS_WITH_OPTIONS } from '../constants'

export interface ReturnPublishPortals {
  associations?: { [key: number]: boolean } | undefined
  [key: string]: any
}

interface ConvertToPublishPortalsProps {
  selectedAssociations: string[]
  selectedPortals: string[]
  selectedAdOptions: {
    portalId: string
    adOptionId: string
    name: string
    available?: number
  }[]
  defaultPortalsSelected?: string[]
  initialAssociations?: any[]
  allAssociationsDefaultSelected?: string[]
}

export const convertToPublishPortals = ({
  selectedAssociations,
  selectedPortals,
  selectedAdOptions,
  defaultPortalsSelected,
  initialAssociations,
  allAssociationsDefaultSelected
}: ConvertToPublishPortalsProps): ReturnPublishPortals => {
  let associations = {}
  const publishPortals: {
    [key: string]: any
  } = {}

  if (initialAssociations) {
    initialAssociations?.forEach((association) => {
      const key = parseInt(association, 10)

      associations = {
        ...associations,
        [key]: Boolean(allAssociationsDefaultSelected?.includes(association))
      }
    })
  }

  selectedAssociations.forEach((association) => {
    const key = parseInt(association, 10)

    associations = {
      ...associations,
      [key]: true
    }
  })

  const filterSelectedPortalsByDefaultPortals = selectedPortals?.filter(
    (portal) =>
      !defaultPortalsSelected?.includes(portal) ||
      PORTALS_WITH_OPTIONS?.includes(portal)
  )

  filterSelectedPortalsByDefaultPortals?.forEach((portal) => {
    const portalKey = `portal_${portal?.toLowerCase()}`

    publishPortals[portalKey] = true

    const adOption = selectedAdOptions?.find(
      (option) => option?.portalId?.toLowerCase() === portal?.toLowerCase()
    )

    if (adOption) {
      publishPortals[`${portalKey}_ad_type`] = adOption?.adOptionId
    }
  })

  const filterPublishPortals = () => {
    if (
      !defaultPortalsSelected?.includes('MONOPOLIO') &&
      !defaultPortalsSelected?.includes('WIGGOT')
    ) {
      return {
        ...publishPortals,
        ...defaultPortalsPublish
      }
    }

    if (!defaultPortalsSelected?.includes('MONOPOLIO')) {
      return {
        ...publishPortals,
        portal_monopolio: true
      }
    }

    if (!defaultPortalsSelected?.includes('WIGGOT')) {
      return {
        ...publishPortals,
        portal_wiggot: true
      }
    }

    return publishPortals
  }

  const filterSelectedAssociationsByDefaultAssociations = Object.keys(
    associations
  ).filter(
    (association) =>
      !allAssociationsDefaultSelected?.includes(association.toString())
  )

  const publishAssociations =
    filterSelectedAssociationsByDefaultAssociations?.length > 0
      ? filterSelectedAssociationsByDefaultAssociations.reduce(
          (acc: any, association: any) => {
            acc[association] = Boolean(
              selectedAssociations.includes(association)
            )
            return acc
          },
          {}
        )
      : undefined

  if (publishAssociations) {
    return {
      ...filterPublishPortals(),
      associations: publishAssociations
    }
  }

  return filterPublishPortals()
}

export interface ReturnPublishPortalsV2 {
  associations: { [key: number]: boolean }
  [key: string]: any
}

export const convertDataToPortalsV2 = ({
  associations,
  portals
}: {
  portals: IDataPortalV2[]
  associations: IDataPortalV2[]
}): ReturnPublishPortals => {
  const publishPortals: ReturnPublishPortalsV2 = {
    associations: {}
  }

  associations?.forEach((association) => {
    if (association?.associationId) {
      const key = parseInt(association?.associationId?.toString(), 10)
      publishPortals.associations[key] = association?.isChecked
    }
  })

  portals?.forEach((portal) => {
    const portalKey = `portal_${portal?.portalId?.toLowerCase()}`
    publishPortals[portalKey] = portal?.isChecked

    const adOptionId = portal?.selectedAdType?.adOptionId
    if (adOptionId && portal?.isChecked) {
      publishPortals[`${portalKey}_ad_type`] = adOptionId
    }
  })

  return {
    ...publishPortals,
    ...defaultPortalsPublish
  }
}
